(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-seller"] && !window.DesignMode) return;
  try {
    
$(document).ready(function() {

  var owl = $(".best-sellers-slider");
 
  owl.owlCarousel({
    autoPlay : true,
    responsive: true,
    items : 2, //10 items above 1000px browser width
    itemsDesktop : [1024,2], //2 items between 1024px and 901px
    itemsDesktopSmall : [900,2], // 2 items betweem 900px and 601px
    itemsTablet: [768,1], //1 items between 768 and 0;
    itemsMobile : [320,1],
    navigation : true,
    slideSpeed : 500,
    pagination : false,
    navigation : true,
  });
 
});  
  
 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-archive"]) return;
  try {
    
$( document ).ready(function() {
	$('.blog_list_main:first-child').addClass('blog_wrapped');
	$('.blog_list_main:nth-child(2)').addClass('blog_wrapped');
<!-- 	$('.blog_list_main:nth-child(3)').addClass('blog_wrapped'); -->
});
   
  
$( ".filter_blogs .selected" ).click(function() {
	$('.blog_list_main:first-child').addClass('blog_wrapped');	
	$('.blog_list_main:nth-child(2)').addClass('blog_wrapped');
<!-- 	$('.blog_list_main:nth-child(3)').addClass('blog_wrapped'); -->
});   

$( ".filter_blogs .blog_other_filter" ).click(function() {
	$('.blog_list_main:first-child').removeClass('blog_wrapped');	
<!-- 	$('.blog_list_main:first-child').addClass('blog_wrapped'); -->
	$('.blog_list_main:nth-child(2)').removeClass('blog_wrapped');
<!-- 	$('.blog_list_main:nth-child(3)').removeClass('blog_wrapped'); --> 
}); 
    


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !window.DesignMode) return;
  try {
    

$( document ).ready(function() {

	$('.panel-heading a').click(function(){
		$('.panel-heading a').removeClass('active');
		$(this).addClass('active');
	});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-banners"] && !window.DesignMode) return;
  try {
    
jQuery(document).ready(function($) {
	$('.countdown_timer').each(function(i) {

		var timerId = '#' + $(this).attr('id');
		var countdownDay = $(this).data('day');
		var countdownMonth = $(this).data('month');
		var countdownYear = $(this).data('year');
		
		$( timerId ).ccountdown(countdownYear, countdownMonth, countdownDay,'00:00'); 
		
	});

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-fullwidth"] && !window.DesignMode) return;
  try {
    
jQuery(document).ready(function($) {
	$('.section_slider').each(function(i) {

		var sliderId = '#' + $(this).attr('id');
		var sliderVar = $(this).attr('id');
		var sliderPagination = '#pagination_' + sliderVar.replace('slideshow_', '');
		var sliderPrev = '#slider_prev_' + sliderVar.replace('slideshow_', '');
		var sliderNext = '#slider_next_' + sliderVar.replace('slideshow_', '');

		var sliderAutoplay = $(this).data('autoplay');
		if ( sliderAutoplay == true ) {
			sliderAutoplay = $(this).data('speed');
		};

		var sliderVar = new Swiper( sliderId, {
			effect: 'fade',
			autoplay: sliderAutoplay,
			loop: true,
			speed: 500,
			autoplayDisableOnInteraction: false,

			pagination: sliderPagination,
			paginationClickable: true,

			prevButton: sliderPrev,
			nextButton: sliderNext,

		});

		$(window).on('load', function() {
			sliderVar.onResize(); // updating swiper after loading

			// TITLE ANIMATION
			if ( $(window).width() > 992 && theme.titleAnimation ){
				$(sliderId + ' .slider_title_animation').each(function() {
					var elemEffect = $(this).data('in-effect');
					$(this).textillate({
						in: {
							effect: elemEffect,
							initialDelay: 0,
						},
						out: {
							effect: 'fadeOut',
						},
						loop: true
					});
				})
			}
		});


		

	});

});

  } catch(e) { console.error(e); }
})();
})();
